import type { Editor } from "@tiptap/core";

export type CellNavDir = "up" | "down" | "left" | "right";

export function editorCellIsEmpty(editor: Editor): boolean {
  return editor.getText({ blockSeparator: "\n" }).trim() === "";
}

export function isCaretAtStart(editor: Editor): boolean {
  if (!editor.state.selection.empty) return false;
  if (editorCellIsEmpty(editor)) return true;
  return editor.state.selection.from <= 1;
}

export function isCaretAtEnd(editor: Editor): boolean {
  if (!editor.state.selection.empty) return false;
  if (editorCellIsEmpty(editor)) return true;
  return editor.state.selection.from >= editor.state.doc.content.size - 1;
}

/** True when Arrow keys should leave this cell (Excel-style). */
export function shouldNavigateOnArrow(
  editor: Editor,
  dir: CellNavDir,
): boolean {
  if (!editor.state.selection.empty && (dir === "up" || dir === "down")) {
    return false;
  }
  if (dir === "left") return isCaretAtStart(editor);
  if (dir === "right") return isCaretAtEnd(editor);
  if (editorCellIsEmpty(editor)) return true;
  const view = editor.view;
  const from = editor.state.selection.from;
  try {
    const here = view.coordsAtPos(from);
    if (dir === "up") {
      const start = view.coordsAtPos(1);
      return here.top <= start.top + 4;
    }
    const endPos = editor.state.doc.content.size;
    const end = view.coordsAtPos(endPos);
    return here.bottom >= end.bottom - 4;
  } catch {
    return false;
  }
}
